module.exports = __webpack_public_path__ + "static/media/Nanaimo.179dc94c.glb";